import EventEmitter from 'events'

import polyfills from './common/polyfills'

import ScrollToSectionCom from './site/scroll-to-section'
import SwiperCom from './common/components/swiper'
import SemanticUICom from './panel/semantic-ui'
import TabsCom from './common/components/tabs'
import FormCom from './common/components/form'
import NavigationCom from './site/navigation'
import WorldMapCom from './site/world-map'
import TextareaCom from './site/textarea'
import TooltipCom from './site/tooltip'
import PlansCom from './site/plans'
import OrderCom from './site/order'
import AuthCom from './site/auth'
import FaqCom from './site/faq'

const app = { events: new EventEmitter() }

document.addEventListener('DOMContentLoaded', function(){
    ScrollToSectionCom()
    SemanticUICom(app)
    NavigationCom()
    OrderCom(app)
    TextareaCom()
    WorldMapCom()
    TooltipCom()
    SwiperCom()
    PlansCom()
    TabsCom()
    FormCom()
    AuthCom()
    FaqCom()
})
